export const FORM_STATUS = {
  INIT: 'init',
  EDITING: 'editing',
  VALIDATION: 'validation',
  VALIDATION_ERROR: 'validation_error',
  SUBMITTING: 'submitting',
  SUCCESS: 'success',
  ERROR: 'error',
}

export const FORM_EVENTS = {
  INIT: 'INIT',

  FIELD_INPUT: 'FIELD_INPUT',
  FIELD_BLUR: 'FIELD_BLUR',
  FIELD_FOCUS: 'FIELD_FOCUS',
  FIELD_ERROR: 'FIELD_ERROR',

  VALIDATION: 'VALIDATION',
  VALIDATION_ERROR: 'VALIDATION_ERROR',

  BACK_STEP: 'BACK_STEP',
  NEXT_STEP: 'NEXT_STEP',

  SUBMIT: 'SUBMIT',
  SUBMIT_SUCCESS: 'SUBMIT_SUCCESS',
  SUBMIT_ERROR: 'SUBMIT_ERROR',

  RESET: 'RESET',
}



// WEBPACK FOOTER //
// ./src/modules/shared/const/form/form.status.js